<div class="jumbotron centered-text">
  U <b>{{data.selectEntities.count}}</b> {{data.selectEntities.count === 1 ? 'záboru' : 'záborů'}} bude nastaven způsob vypořádání <b>{{data.details.occupationSolutionType.name}}</b>.
  <ng-container *ngIf="data.details.finalSolutionReasonCancellation">
    <br/><br/>
    <span>Důvod zrušení: <b>{{data.details.finalSolutionReasonCancellation}}</b></span>
  </ng-container>
</div>
